module.exports = __webpack_public_path__ + "1.2f14bafe9bbae897929f.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/assets/img/1.jpg
// module id = ../../../../../src/assets/img/1.jpg
// module chunks = styles